import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import NextIcon from '@material-ui/icons/SkipNext';
import PrevIcon from '@material-ui/icons/SkipPrevious';
import Button from '@material-ui/core/Button';
import CorrectIcon from '@material-ui/icons/Done';
import IncorrectIcon from '@material-ui/icons/Clear';
import Paper from '@material-ui/core/Paper';
import { Swipeable } from 'react-swipeable';

let active = true;
let timeout = 0;

const useStyles = makeStyles(theme => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      width: 700,
      maxWidth: '100%',
      padding: 20,
      maxHeight: '100%',
      overflow: 'auto',
    },
    '& h3': {
      color: '#999',
      textAlign: 'center',
      userSelect: 'none',
      marginBottom: '1.5em',
      fontWeight: 500,
    },
  },
  english: {
    textAlign: 'center',
    width: 450,
    maxWidth: '100%',
    padding: '1em',
    margin: '0 auto',
    userSelect: 'none',
    marginBottom: 20,
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  polish: {
    textAlign: 'center',
    width: 450,
    maxWidth: '100%',
    padding: '1em',
    margin: '0 auto',
    userSelect: 'none',
    position: 'relative',
    paddingBottom: '1em',
    cursor: 'pointer',
    '& svg': {
      position: 'absolute',
      bottom: '0.1em',
      left: '50%',
      marginLeft: '-0.5em',
      fontSize: '2em',
    },
  },
  ok: {
    color: theme.palette.success.main,
  },
  notOk: {
    color: theme.palette.error.main,
  },
  pagination: {
    textAlign: 'center',
    margin: '1em 0',
  },
  sample: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.secondary.main,
    fontFamily: theme.typography.body1.fontFamily,
  },
  action: {
    textAlign: 'center',
    verticalAlign: 'middle',
    marginTop: 20,
    '& button': {
      margin: '0 3px',
      verticalAlign: 'middle',
    },
  },
  '@media(max-width: 850px)': {

  }
}));

function ReadAndUnderstand(props) {
  const classes = useStyles();
  const [ en, setEn ] = useState([]);
  const [ pl, setPl ] = useState([]);
  const [ no, setNo ] = useState(0);
  const [ plNo, setPlNo ] = useState(0);
  const [ finished, setFinished ] = useState(false);
  const [ ok, setOk ] = useState(false);
  const [ notOk, setNotOk ] = useState(false);
  const { exercise, startStats, finishExercise, action, type, close } = props.exerciseProps;
  const len = exercise.length;
  const plRef = useRef(null);

  useEffect(() => {
    init();
    return () => {
      clearTimeout(timeout);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!exercise.length) return;
    setEn(exercise.map((t, id) => { 
      return { text: t.text, id };
    }));
    setPl(shuffle(exercise.map((t, id) => { 
      return { text: t.translation, id };
    })));
    // eslint-disable-next-line
  }, [exercise]);

  const init = () => {
    startStats(type);
    setFinished(false);
  }

  const next = () => {
    if (no < len - 1) setNo(no + 1);
    action();
  }

  const nextPl = () => {
    if (!active) return;
    if (plNo < pl.length - 1) {
      setPlNo(plNo + 1);
    } else {
      setPlNo(0);
    }
    action();
  }
  
  const prevPl = () => {
    if (!active) return;
    if (plNo > 0) {
      setPlNo(plNo - 1);
    } else {
      setPlNo(pl.length - 1);
    }
    action();
  }

  const correct = () => {
    const newPl = [ ...pl ];
    newPl.splice(plNo, 1);
    const lenPl = newPl.length;
    if (no === len - 1) return finish();
    const animate1 = () => {
      setOk(true);
      timeout = setTimeout(() => {
        animate2();
      }, 850);
    }
    const animate2 = () => {
      ref.classList.add('animated');
      ref.classList.add('zoomOut');
      timeout = setTimeout(() => {
        ref.classList.remove('animated');
        ref.classList.remove('zoomOut');
        afterAnimate();
      }, 400);
    }
    const afterAnimate = () => {
      setOk(false);
      if (plNo >= lenPl - 1) {
        const newNo = Math.max(0, lenPl - 1);
        setPlNo(newNo);
      }
      setPl(newPl);
      active = true;
      next();
    }
    const ref = plRef.current;
    props.media.success();
    active = false;
    animate1();
  }

  const incorrect = () => {
    active = false;
    const ref = plRef.current;
    props.media.failure();
    const animate1 = () => {
      setNotOk(true);
      timeout = setTimeout(() => {
        animate2();
      }, 850);
    }
    const animate2 = () => {
      ref.classList.add('animated');
      ref.classList.add('shake');
      timeout = setTimeout(() => {
        ref.classList.remove('animated');
        ref.classList.remove('shake');
        setNotOk(false);
        active = true;
      }, 750);
    }
    animate1();
  }

  const finish = () => {
    props.media.finish();
    finishExercise();
    setFinished(true);
  }

  const checkAnswer = () => {
    action();
    if (!active) return;
    const result = pl[plNo].id === en[no].id;
    if (result) {
      correct();
    } else {
      incorrect();
    }
  }

  if (!pl.length) return '';

  return (
    <div className={classes.wrapper}>
      <div>
        <h3>Dopasuj tłumaczenie do angielskiego tekstu</h3>

        <Paper className={classes.english}>
          <p>{en[no].text}</p>
        </Paper>
        <Swipeable className={classes.container} onSwipedRight={prevPl} onSwipedLeft={nextPl} delta={40} >
          <Paper className={classes.polish} ref={plRef} onClick={checkAnswer}>
            <p>{pl[plNo].text}</p>
            {ok && <CorrectIcon className={classes.ok} />}
            {notOk && <IncorrectIcon className={classes.notOk} />}
          </Paper>
        </Swipeable>


        <div className={classes.pagination}>{no + 1}/{len}</div>

        {!finished && <div className={classes.action}>
          <Button variant="outlined" color="secondary" onClick={prevPl}><PrevIcon /></Button>
          <Button variant="outlined" color="secondary" onClick={checkAnswer}>Sprawdź</Button>
          <Button variant="outlined" color="secondary" onClick={nextPl}><NextIcon /></Button>
        </div>}
        {finished && <div className={classes.action}>
          <Button variant="outlined" color="secondary" onClick={close}>Zamknij</Button>
        </div>}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { 
    media: state.media,
    mobile: state.mobile,
  }
}

function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;
  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

export default connect(mapStateToProps)(ReadAndUnderstand);